import { useCallback, useEffect, useState } from "react";
import i18next from "i18next";
import { LocalizationService } from "../../services/AppLocalizationService";
import { TENANT_ID, getCurrentLanguage } from "../../components/Utils";

export const APP_LANGUAGES = [
  { code: "en_IN", short: "EN", name: "English" },
  { code: "hi_IN", short: "हि", name: "हिन्दी" },
];

export const useAppLanguage = () => {
  const [appLanguage, setAppLanguage] = useState(getCurrentLanguage() || "en_IN");

  useEffect(() => {
    i18next.on("languageChanged", setAppLanguage);
    return () => i18next.off("languageChanged", setAppLanguage);
  }, []);

  const handleLanguageChange = useCallback(async (lang) => {
    await LocalizationService.changeLanguage(lang, TENANT_ID);
    setAppLanguage(lang);
  }, []);

  return { appLanguage, handleLanguageChange };
};

export default useAppLanguage;
